export default __webpack_public_path__ + "static/media/sad-cat.b0bbf8a0.gif";